import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate
import logo from '../assets/logocip.png';
import Header from '../components/Header';
import image1 from '../assets/1.png';
import image2 from '../assets/2.png';
import cutDirectlyFromPotatoes from '../assets/cut-directly-from-potatoes.svg';
import svg111 from '../assets/111.svg';
import svg222 from '../assets/222.svg';
import photo1 from '../assets/photo_5246949241451052631_y.jpg';
import photo3 from '../assets/photo_5246949241451052633_y.jpg';
import photo4 from '../assets/photo_5246949241451052634_y.jpg';
import image4 from '../assets/4.jpeg';
import image5 from '../assets/5.jpeg';
import image6 from '../assets/6.jpeg';
import image7 from '../assets/7.jpeg';

// СНАЧАЛА объявляем fadeIn!
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Date despre chipsuri
const chipsImages = [
  photo1,
  photo3,
  photo4,
  image4,
  image5,
  image6,
  image7,
];

const yellow = '#f3e81c';
const black = '#181818';
const accentColor = '#FF6B00'; // Culoare de accent portocalie

const PageWrapper = styled.div`
  min-height: 100vh;
  min-height: 100dvh; /* Dynamic viewport height for mobile */
  background: ${yellow};
  font-family: 'Inter', Arial, sans-serif;
  position: relative;
  overflow: hidden;
  
  /* Ensure proper rendering on all devices */
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const BackgroundPattern = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: radial-gradient(circle at 10% 20%, rgba(0,0,0,0.03) 0%, transparent 8%),
                    radial-gradient(circle at 90% 80%, rgba(0,0,0,0.03) 0%, transparent 8%);
  background-size: 60px 60px;
  z-index: 0;
`;

const BackgroundPhoto = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  width: 50vw;
  height: 100vh;
  object-fit: cover;
  object-position: center right;
  z-index: 0;
  pointer-events: none;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    width: 55vw;
    object-position: center right;
  }
  
  @media (max-width: 768px) {
    top: calc(50vh - 3px);
    right: 0;
    left: 0;
    width: 100vw;
    height: calc(50vh + 3px);
    object-position: center center;
    object-fit: cover;
  }
  
  @media (max-width: 480px) {
    top: calc(48vh + 0px);
    height: calc(52vh + 0px);
  }
  
  @media (max-width: 375px) {
    top: calc(45vh + 14px);
    height: calc(55vh - 14px);
  }
  
  @media (max-width: 320px) {
    top: calc(42vh + 16px);
    height: calc(58vh - 16px);
  }
`;

const waveAnim = keyframes`
  0% { 
    transform: translateX(0px); 
    -webkit-transform: translateX(0px);
    -moz-transform: translateX(0px);
    -ms-transform: translateX(0px);
  }
  50% { 
    transform: translateX(4px); 
    -webkit-transform: translateX(4px);
    -moz-transform: translateX(4px);
    -ms-transform: translateX(4px);
  }
  100% { 
    transform: translateX(0px); 
    -webkit-transform: translateX(0px);
    -moz-transform: translateX(0px);
    -ms-transform: translateX(0px);
  }
`;

const waveAnimMobile = keyframes`
  0% { 
    transform: translateX(0px); 
    -webkit-transform: translateX(0px);
    -moz-transform: translateX(0px);
    -ms-transform: translateX(0px);
  }
  50% { 
    transform: translateX(-8px); 
    -webkit-transform: translateX(-8px);
    -moz-transform: translateX(-8px);
    -ms-transform: translateX(-8px);
  }
  100% { 
    transform: translateX(0px); 
    -webkit-transform: translateX(0px);
    -moz-transform: translateX(0px);
    -ms-transform: translateX(0px);
  }
`;

const WaveDivider = styled.div`
  position: absolute;
  top: 0;
  left: calc(50vw - 20px);
  width: 120px;
  height: 100vh;
  z-index: 2;
  pointer-events: none;
  overflow: hidden;
  
  @media (max-width: 900px) and (min-width: 769px) {
    left: calc(50vw - 10px);
    width: 60px;
  }
  
  @media (max-width: 768px) {
    top: calc(50vh - 20px);
    left: 0;
    width: 100vw;
    height: 60px;
  }
  
  @media (max-width: 480px) {
    top: calc(48vh - 15px);
    height: 55px;
  }
  
  @media (max-width: 375px) {
    top: calc(45vh + 14px);
    height: 50px;
  }
  
  @media (max-width: 320px) {
    top: calc(42vh + 14px);
    height: 45px;
  }
  .desktop-wave {
    animation: ${waveAnim} 5s ease-in-out infinite;
    -webkit-animation: ${waveAnim} 5s ease-in-out infinite;
    -moz-animation: ${waveAnim} 5s ease-in-out infinite;
    -ms-animation: ${waveAnim} 5s ease-in-out infinite;
    will-change: transform;
    
    @media (max-width: 768px) {
      display: none !important;
    }
  }
  
  .mobile-wave {
    animation: ${waveAnimMobile} 4s ease-in-out infinite;
    -webkit-animation: ${waveAnimMobile} 4s ease-in-out infinite;
    -moz-animation: ${waveAnimMobile} 4s ease-in-out infinite;
    -ms-animation: ${waveAnimMobile} 4s ease-in-out infinite;
    will-change: transform;
    
    @media (min-width: 769px) {
      display: none !important;
    }
    @media (max-width: 768px) {
      display: block !important;
    }
  }
`;

const MainSection = styled.section`
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh; /* Dynamic viewport height */
  position: relative;
  z-index: 1;
  padding: 0;
  background: none;
  border-radius: 0;
  box-shadow: none;
  border: none;
  margin: 0;
  max-width: none;
  
  @media (max-width: 768px) {
    flex-direction: column;
    height: 50vh;
    height: 50dvh;
  }
  
  @media (max-width: 480px) {
    height: 48vh;
    height: 48dvh;
  }
  
  @media (max-width: 375px) {
    height: 45vh;
    height: 45dvh;
  }
  
  @media (max-width: 320px) {
    height: 42vh;
    height: 42dvh;
  }
`;

const LeftBlock = styled.div`
  flex: 0 0 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px 2rem 3rem 4rem;
  z-index: 2;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    flex: 0 0 45%;
    padding: 0px 1.5rem 2rem 3rem;
  }
  
  @media (max-width: 768px) {
    flex: 0 0 55vh;
    flex: 0 0 55dvh;
    padding: clamp(100px, 15vh, 140px) 1.5rem 3rem 1.5rem;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    width: 100%;
  }
  
  @media (max-width: 600px) {
    padding: clamp(90px, 13vh, 120px) 1.5rem 3rem 1.5rem;
  }
  
  @media (max-width: 480px) {
    flex: 0 0 48vh;
    flex: 0 0 48dvh;
    padding: clamp(80px, 11vh, 110px) 1.2rem 2rem 1.2rem;
    justify-content: flex-start;
  }
  
  @media (max-width: 375px) {
    flex: 0 0 45vh;
    flex: 0 0 45dvh;
    padding: clamp(70px, 9vh, 100px) 1rem 1.5rem 1rem;
  }
  
  @media (max-width: 320px) {
    flex: 0 0 42vh;
    flex: 0 0 42dvh;
    padding: clamp(80px, 12vh, 120px) 0.8rem 1rem 0.8rem;
  }
  
  @media (max-width: 280px) {
    flex: 0 0 40vh;
    flex: 0 0 40dvh;
    padding: clamp(25px, 3vh, 50px) 0.6rem 0.8rem 0.6rem;
  }
`;

const RightBlock = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  /* background: #f0f0f0; */
  clip-path: none;
  margin-left: 0;
  padding: 0;
  padding-top: 0;
  padding-left: 0;
  height: 100vh;
  z-index: 1;
  overflow: hidden;
  
  @media (max-width: 768px) {
    flex: 0 0 50vh;
    height: 50vh;
  }
  
  @media (max-width: 480px) {
    flex: 0 0 52vh;
    height: 52vh;
  }
  
  @media (max-width: 375px) {
    flex: 0 0 55vh;
    height: 55vh;
  }
  
  @media (max-width: 320px) {
    flex: 0 0 58vh;
    height: 58vh;
  }
`;

const Badge = styled.div`
  background: ${accentColor};
  color: white;
  font-size: 0.9rem;
  font-weight: 700;
  font-family: 'Roboto Black', 'Roboto', Arial, sans-serif;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 12px rgba(255, 107, 0, 0.3);
  
  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: 0.85rem;
    padding: 0.45rem 0.9rem;
    margin-bottom: 1.3rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.1rem;
    padding: 0.4rem 0.8rem;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 375px) {
    font-size: 1.0rem;
    padding: 0.3rem 0.7rem;
    margin-bottom: 1.2rem;
  }

  @media (max-width: 320px) {
    font-size: 0.95rem;
    padding: 0.25rem 0.6rem;
    margin-bottom: 2rem;
    margin-top: 1.5rem;
  }
`;

const HeroTitle = styled.h1`
  font-size: clamp(1.6rem, 4vw, 2.2rem);
  font-weight: 800;
  font-family: 'Cubano', 'Arial Black', Arial, sans-serif;
  color: ${black};
  margin-bottom: clamp(0.4rem, 2vh, 1.2rem);
  line-height: 1.1;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: clamp(1.8rem, 3.5vw, 2.0rem);
    margin-bottom: 1rem;
    line-height: 1.15;
  }
  
  @media (max-width: 768px) {
    font-size: clamp(2rem, 5vw, 2.4rem);
    margin-bottom: clamp(2.2rem, 5vh, 3rem);
    max-width: 90%;
    margin-top: clamp(-1rem, -2vh, -0.3rem);
  }

  @media (max-width: 480px) {
    font-size: clamp(1.8rem, 4.5vw, 2.2rem);
    margin-bottom: clamp(1.8rem, 4vh, 2.5rem);
    margin-top: clamp(-0.8rem, -1.5vh, -0.2rem);
    line-height: 1.15;
  }

  @media (max-width: 375px) {
    font-size: clamp(1.6rem, 4vw, 2.0rem);
    margin-bottom: clamp(1.5rem, 3vh, 2.2rem);
    line-height: 1.2;
    margin-top: clamp(-1rem, -2vh, -0.5rem);
  }

  @media (max-width: 320px) {
    font-size: clamp(1.4rem, 3.5vw, 1.8rem);
    margin-bottom: 2rem;
    line-height: 1.25;
    margin-top: 1rem;
  }

  @media (max-width: 280px) {
    font-size: clamp(1.2rem, 3vw, 1.6rem);
    margin-bottom: clamp(0.2rem, 0.6vh, 0.4rem);
    line-height: 1.3;
    margin-top: clamp(-2.5rem, -4vh, -1.5rem);
  }
`;

const HeroDesc = styled.p`
  font-size: clamp(1.1rem, 2.5vw, 1.3rem);
  font-family: 'Roboto Black', 'Roboto', Arial, sans-serif;
  color: #555;
  margin-bottom: clamp(0.5rem, 3vh, 1.5rem);
  max-width: 420px;
  line-height: 1.7;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    font-size: clamp(1.1rem, 2.2vw, 1.2rem);
    margin-bottom: 1.2rem;
    max-width: 380px;
    line-height: 1.6;
  }
  
  @media (max-width: 768px) {
    font-size: clamp(1.2rem, 3vw, 1.5rem);
    margin-bottom: clamp(3rem, 6vh, 4rem);
    max-width: 85%;
    margin-top: clamp(0.5rem, 1vh, 1rem);
  }

  @media (max-width: 480px) {
    font-size: clamp(1.1rem, 2.8vw, 1.4rem);
    margin-bottom: clamp(2.5rem, 5vh, 3.5rem);
    line-height: 1.4;
    margin-top: clamp(0.3rem, 0.8vh, 0.8rem);
  }

  @media (max-width: 375px) {
    font-size: clamp(1rem, 2.5vw, 1.3rem);
    margin-bottom: clamp(2.2rem, 4vh, 3rem);
    line-height: 1.45;
    margin-top: clamp(0.2rem, 0.5vh, 0.6rem);
  }

  @media (max-width: 320px) {
    font-size: clamp(0.9rem, 2.2vw, 1.2rem);
    margin-bottom: 2.5rem;
    line-height: 1.4;
    margin-top: 1.2rem;
  }
`;

const PriceTag = styled.div`
  font-size: 2.2rem;
  font-weight: 800;
  font-family: 'Roboto Black', 'Roboto', Arial, sans-serif;
  color: ${accentColor};
  margin-bottom: 2.5rem;
  display: flex;
  align-items: center;
  background: rgba(255, 107, 0, 0.1);
  padding: 0.8rem 1.5rem;
  border-radius: 20px;
  border: 2px solid rgba(255, 107, 0, 0.2);
  backdrop-filter: blur(5px);
  &:before {
    content: 'Preț:';
    font-size: 1.1rem;
    color: #666;
    margin-right: 0.8rem;
    font-weight: 500;
  }
  @media (max-width: 700px) {
    font-size: 1.2rem;
    padding: 0.5rem 0.8rem;
    margin-bottom: 1.2rem;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: clamp(0.5rem, 1.5vh, 0.8rem);
    width: 100%;
    max-width: clamp(240px, 60vw, 300px);
    margin-bottom: clamp(1.5rem, 4vh, 3rem);
    margin-top: clamp(-1.5rem, -2vh, -0.8rem);
  }
  
  @media (max-width: 600px) {
    margin-bottom: clamp(1.5rem, 4vh, 3rem);
    margin-top: clamp(-1.3rem, -1.5vh, -0.7rem);
  }
  
  @media (max-width: 480px) {
    margin-bottom: clamp(1rem, 3vh, 2rem);
    max-width: clamp(220px, 55vw, 280px);
    margin-top: clamp(-1.3rem, -1.5vh, -0.7rem);
    gap: clamp(0.4rem, 1vh, 0.6rem);
  }
  
  @media (max-width: 375px) {
    margin-bottom: clamp(0.8rem, 2.5vh, 1.5rem);
    max-width: clamp(200px, 50vw, 260px);
    margin-top: clamp(-2rem, -2.5vh, -1.3rem);
  }
  
  @media (max-width: 320px) {
    margin-bottom: 3rem;
    max-width: clamp(180px, 45vw, 240px);
    margin-top: 1rem;
    gap: clamp(0.3rem, 0.8vh, 0.5rem);
  }
`;

const OrderButton = styled.button`
  background: #000000;
  color: white;
  border: none;
  padding: clamp(0.6rem, 2vh, 1rem) clamp(1rem, 4vw, 2rem);
  border-radius: 50px;
  font-size: clamp(1rem, 2.5vw, 1.1rem);
  font-weight: 700;
  font-family: 'Roboto Black', 'Roboto', Arial, sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  min-height: 44px; /* Minimum touch target size */
  
  &:hover {
    background: #111111;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 1024px) and (min-width: 769px) {
    padding: clamp(0.8rem, 1.8vh, 0.9rem) clamp(1.5rem, 3.5vw, 1.8rem);
    font-size: clamp(1rem, 2.2vw, 1.05rem);
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding: clamp(0.7rem, 1.8vh, 0.9rem) clamp(1.2rem, 3vw, 1.5rem);
    font-size: clamp(1.1rem, 2.8vw, 1.3rem);
  }

  @media (max-width: 480px) {
    padding: clamp(0.6rem, 1.5vh, 0.8rem) clamp(1rem, 2.5vw, 1.3rem);
    font-size: clamp(1.05rem, 2.5vw, 1.25rem);
  }

  @media (max-width: 375px) {
    padding: clamp(0.5rem, 1.2vh, 0.7rem) clamp(0.9rem, 2vw, 1.1rem);
    font-size: clamp(1rem, 2.2vw, 1.2rem);
  }

  @media (max-width: 320px) {
    padding: clamp(0.4rem, 1vh, 0.6rem) clamp(0.8rem, 1.8vw, 1rem);
    font-size: clamp(0.95rem, 2vw, 1.15rem);
  }
`;

const ChipImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover;
  object-position: center right;
  animation: ${fadeIn} 0.8s ease-out forwards;
  filter: drop-shadow(0 10px 20px rgba(0,0,0,0.15));
  z-index: 0;
  
  @media (max-width: 768px) {
    object-position: center top;
    height: 100%;
  }
`;

const NavigationDots = styled.div`
  position: absolute;
  left: 0;
  bottom: 32px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  z-index: 2;
`;

const Dot = styled.button`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid ${accentColor};
  background: ${({ active }) => (active ? accentColor : 'transparent')};
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 0;
`;

const BottomLeftImages = styled.div`
  position: absolute;
  bottom: 20px;
  left: 20px;
  display: flex;
  gap: 10px;
  z-index: 3;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const BottomImagesColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const BottomImagesRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: flex-start;
  margin-top: 0px;
`;

const BottomImage = styled.img`
  width: 150px;
  height: auto;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    width: 130px;
  }

  @media (max-width: 768px) {
    width: 100px;
  }

  @media (max-width: 480px) {
    width: 80px;
  }
`;

const CutPotatoesImage = styled.img`
  width: 200px;
  height: auto;
  border-radius: 10px;
  
  @media (max-width: 1024px) and (min-width: 769px) {
    width: 170px;
  }
  
  @media (max-width: 768px) {
    width: 130px;
  }
  
  @media (max-width: 480px) {
    width: 110px;
  }
`;

// Мобильные SVG изображения для хаотичного расположения
const MobileSVGImages = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 50vh;
  z-index: 4;
  pointer-events: none;
  display: none;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileSVG = styled.img`
  position: absolute;
  border-radius: 8px;
  filter: drop-shadow(0 2px 8px rgba(0,0,0,0.1));
  transition: transform 0.3s ease;
  
  &.svg-111 {
      width: clamp(85px, 20vw, 105px);
      top: clamp(120px, 18vh, 160px);
      right: clamp(15px, 4vw, 25px);
      transform: rotate(-15deg);
    }
  
  &.svg-222 {
     width: clamp(75px, 18vw, 95px);
     top: clamp(135px, 18vh, 180px);
     left: clamp(20px, 5vw, 30px);
     transform: rotate(12deg);
   }
  
  &.cut-potatoes {
    width: clamp(110px, 26vw, 140px);
    top: clamp(280px, 40vh, 330px);
    right: clamp(15px, 5vw, 40px);
    transform: rotate(-8deg);
  }
  
  @media (max-width: 480px) {
    &.svg-111 {
        width: clamp(160px, 36vw, 190px);
        top: clamp(60px, 10vh, 100px);
        right: clamp(-35px, 0.5vw, 0px);
      }
    
    &.svg-222 {
       width: clamp(85px, 22vw, 110px);
       top: clamp(90px, 15vh, 150px);
       left: clamp(15px, 4vw, 25px);
     }
    
    &.cut-potatoes {
      width: clamp(220px, 50vw, 250px);
      top: clamp(280px, 40vh, 320px);
      right: clamp(-25px, 0vw, -5px);
    }
  }
  
  @media (max-width: 430px) and (min-width: 415px) {
       &.svg-111 {
           width: clamp(155px, 34vw, 175px);
           top: clamp(55px, 9vh, 95px);
           right: clamp(-85px, 0vw, -80px);
         }
      
      &.svg-222 {
         width: clamp(85px, 20vw, 100px);
         top: clamp(50px, 12vh, 100px);
         left: clamp(12px, 3vw, 20px);
       }
      
      &.cut-potatoes {
        width: clamp(215px, 45vw, 240px);
        top: clamp(330px, 46vh, 360px);
        right: clamp(-28px, 0vw, -10px);
      }
    }
    
    @media (max-width: 414px) and (min-width: 376px) {
      &.svg-111 {
          width: clamp(155px, 34vw, 175px);
          top: clamp(55px, 9vh, 95px);
          right: clamp(-90px, 0vw, -85px);
        }
      
      &.svg-222 {
         width: clamp(85px, 20vw, 100px);
         top: clamp(50px, 12vh, 100px);
         left: clamp(12px, 3vw, 20px);
       }
      
      &.cut-potatoes {
         width: clamp(215px, 45vw, 240px);
         top: clamp(290px, 42vh, 320px);
         right: clamp(-28px, 0vw, -10px);
       }
    }
  
  @media (max-width: 375px) {
    &.svg-111 {
        width: clamp(155px, 34vw, 175px);
        top: clamp(55px, 9vh, 95px);
        right: clamp(-80px, 0vw, -75px);
      }
    
    &.svg-222 {
       width: clamp(85px, 20vw, 100px);
       top: clamp(50px, 12vh, 100px);
       left: clamp(12px, 3vw, 20px);
     }
    
    &.cut-potatoes {
      width: clamp(215px, 45vw, 240px);
      top: clamp(270px, 39vh, 300px);
      right: clamp(-28px, 0vw, -10px);
    }
  }
  
  @media (max-width: 320px) {
    &.svg-111 {
        width: clamp(150px, 32vw, 170px);
        top: clamp(50px, 8vh, 85px);
        right: clamp(-70px, 0vw, -55px);
      }
    
    &.svg-222 {
       width: clamp(80px, 18vw, 95px);
       top: clamp(90px, 12vh, 120px);
       left: clamp(8px, 2vw, 15px);
     }
    
    &.cut-potatoes {
      width: clamp(210px, 42vw, 235px);
      top: clamp(260px, 36vh, 290px);
      right: clamp(-30px, 0vw, -15px);
    }
  }
`;

const Home = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setAnimate(true);
  }, []);

  useEffect(() => {
    if (!chipsImages.length) return;
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % chipsImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (currentImage >= chipsImages.length) {
      setCurrentImage(0);
    }
  }, [currentImage, chipsImages.length]);

  if (!animate || !chipsImages.length) return null;

  const handleOrderClick = () => {
    navigate('/shop');
  };

  return (
    <PageWrapper>
      <BackgroundPhoto
        src={chipsImages[currentImage]}
        alt="Фото чипсов или друзей"
      />
      <MobileSVGImages>
        <MobileSVG 
          src={svg111} 
          alt="111 SVG" 
          className="svg-111"
        />
        <MobileSVG 
          src={svg222} 
          alt="222 SVG" 
          className="svg-222"
        />
        <MobileSVG 
          src={cutDirectlyFromPotatoes} 
          alt="Cut Directly From Potatoes" 
          className="cut-potatoes"
        />
      </MobileSVGImages>
      <WaveDivider>
        {/* Вертикальная волна для десктопа */}
        <svg className="desktop-wave" width="100%" height="100%" viewBox="0 0 120 1000" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" style={{display:'block',height:'100vh',width:'100%'}}>
          <path d="M120,0 C100,50 140,100 60,150 C-20,200 140,300 60,400 C-20,500 140,600 60,700 C-20,800 140,900 60,950 C100,975 120,1000 0,1000 L0,0 Z" fill="#f3e81c" />
          <path d="M120,0 C100,50 140,100 60,150 C-20,200 140,300 60,400 C-20,500 140,600 60,700 C-20,800 140,900 60,950 C100,975 120,1000 0,1000" fill="none" stroke="#fff" strokeWidth="6" opacity="0.18" />
        </svg>
        {/* Горизонтальная волна для мобильных */}
        <svg 
           className="mobile-wave" 
           width="100%" 
           height="60px" 
           viewBox="0 0 2000 120" 
           preserveAspectRatio="none" 
           xmlns="http://www.w3.org/2000/svg" 
           style={{ width: "120vw", height: "60px", marginLeft: "-10vw" }} 
         > 
           {/* Жёлтая волна */} 
           <path 
             d="M0,60  
                C125,0 250,95 375,40  
                C500,0 625,95 750,40  
                C875,0 1000,95 1125,40 
                C1250,0 1375,95 1500,40
                C1625,0 1750,95 1875,40
                C2000,0 2125,95 2000,40  
                L2000,0 L0,0 Z" 
             fill="#f3e81c" 
           /> 
          
 
         </svg>
      </WaveDivider>
      <Header />
      <MainSection>
        <LeftBlock>
            <HeroTitle>Gust intens, crocant și delicios!</HeroTitle>
        <HeroDesc>
            Leodor — chipsurile autentice care aduc bucurie la fiecare mușcătură. Fără gluten. Calitate superioară
          </HeroDesc>
          <ActionButtons>
            <OrderButton onClick={handleOrderClick}>Comanda acum</OrderButton>
          </ActionButtons>
        </LeftBlock>
        <RightBlock>
          {/* NavigationDots удалены по просьбе пользователя */}
        </RightBlock>
      </MainSection>
      
      <BottomLeftImages>
        <BottomImagesColumn>
          <BottomImage 
            src={image1} 
            alt="Изображение 1" 
            onClick={() => window.open('https://reclamatiisal.anpc.ro/', '_blank')}
          />
          <BottomImagesRow>
            <BottomImage 
              src={image2} 
              alt="Изображение 2" 
              onClick={() => window.open('https://consumer-redress.ec.europa.eu/site-relocation_en?event=main.home2.show&lng=RO', '_blank')}
            />
            <CutPotatoesImage src={cutDirectlyFromPotatoes} alt="Cut Directly From Potatoes" />
          </BottomImagesRow>
        </BottomImagesColumn>
        <BottomImage src={svg111} alt="111 SVG" />
        <BottomImage src={svg222} alt="222 SVG" />
      </BottomLeftImages>
    </PageWrapper>
  );
};

export default Home;